import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import annotations from './pdfjs/annotations/reducers'
import thunk from 'redux-thunk'

import _document from './pdfjs/document/reducers'

const reducer = combineReducers({
  annotations: annotations,
  document: _document,
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default createStore(reducer, composeEnhancers(applyMiddleware(thunk)))
